// src/pages/ServicesPage.js
import React from "react";
import "../styles/css/style.css";
import "../styles/css/bootstrap.min.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ServicesSection from "../components/ServicesSection";
import ServicesSection_detaild from "../components/ServicesSection_detaild";
import ERPModulesAndStats from "../components/ERPModulesAndStats";


const ServicesPage = () => {
  return (
    <>
          <Header/>
      {/* Header */}
      <div className="container-fluid" style={{ backgroundColor: "transparent" }}>
        <div className="container text-center py-5" style={{ maxWidth: "900px" }}>
          <h3
            className="display-3 mb-4"
            data-aos="fade-down"
            style={{ color: "#A71717" }}
          >
            Our Services
          </h3>
          <p className="text-dark mb-4" data-aos="fade-up">
            Empowering Ethiopian Businesses with Innovative Solutions
          </p>
        </div>
      </div>

      {/* Services Section */}
      <ServicesSection />
      <ServicesSection_detaild />
      <ERPModulesAndStats />

            <Footer />

    </>
  );
};

export default ServicesPage;
